/* ============================================================================
   VANGUARD PRODUCT SYSTEM — v-sticky-atc.js
   ----------------------------------------------------------------------------
   Muestra la barra de compra fija solo a partir del segundo bloque, es decir
   cuando el Hero ha salido de pantalla. Mientras el Hero se ve, su propio CTA
   ya está a la vista y repetirlo abajo solo añade ruido.

   Se resuelve con IntersectionObserver sobre la sección del Hero, no con
   listeners de scroll: el navegador hace el cálculo fuera del hilo principal
   y no hay trabajo en cada píxel desplazado.

   MEJORA PROGRESIVA: la clase que oculta la barra la añade este script. Sin
   JS, o si no hay IntersectionObserver, la barra queda visible siempre, que
   es el comportamiento anterior y nunca deja al usuario sin CTA.
   ============================================================================ */

(function () {
  'use strict';

  function initStickyAtc() {
    var bar = document.querySelector('.v-product-sticky');
    if (!bar) return;

    var hero = document.querySelector('.v-product-hero');

    // Sin Hero que observar o sin soporte: se deja visible.
    if (!hero || typeof window.IntersectionObserver !== 'function') return;

    bar.classList.add('v-product-sticky--auto');

    // Aparece siempre que el botón "Agregar al carrito" de la ficha NO se ve: al abrir la ficha en la galería (el botón está más abajo) y cuando ya lo pasaste;
    // si la ficha no tiene ese botón, usa el final de la sección del producto.
    var mainBtn = hero.querySelector('.v-product-hero__cta .v-atc__button');
    var ticking = false;
    function update() {
      ticking = false;
      var ref = mainBtn && mainBtn.offsetParent !== null ? mainBtn : hero;
      var r = ref.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0 || r.top >= window.innerHeight);
    }
    function onScroll() { update(); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', function () {
    initStickyAtc();
  });
})();
